<template>
  <div>
    <Header></Header>
    <router-view :key="$route.fullPath"></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      env: process.env,
      loading: true,
    };
  },
  computed: {
    cities() {
      return Object.assign({}, this.$store.getters.cities);
    },
  },
  methods: {
    getCities() {
      this.$store
        .dispatch("getCities")
        .then((response) => {
          this.loading = false;

          if (response.status == 200) {
            this.loading = false;

            return true;
          } else {
            this.error = response.data.message;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.error = error.message;
        });
    },
  },
  mounted() {
    this.getCities();
  },
};
</script>
